


























import Vue, { VueConstructor } from 'vue';
import Stars from './components/Stars.vue';
import GithubIcon from 'vue-material-design-icons/GithubCircle.vue';
import Linkedin from 'vue-material-design-icons/Linkedin.vue';
import Twitter from 'vue-material-design-icons/Twitter.vue';
import Project from '@/components/Project.vue';
import { createComponent, ref } from '@vue/composition-api';
import { PortfolioType, Portfolio } from './models';
import { PathReporter } from 'io-ts/lib/PathReporter';
import { pipe } from 'fp-ts/lib/pipeable';
import { fold, left } from 'fp-ts/lib/Either';

const LinkIcon = (icon: any) => Vue.extend({
  name: icon.name + 'Link',
  props: {
    link: String,
  },
  render(h) {
    return h(
      'a',
      {
        attrs: {
          target: '_blank',
          href: this.$props.link,
          style: 'text-decoration: none; color: white',
        },
      },
      [h(icon)],
    );
  },
});

// TODO
// 1. Google analytics
// Grab GitHub stars information

export default createComponent({
  name: 'app',
  components: {
    Stars,
    Project,
    GithubIcon: LinkIcon(GithubIcon),
    Linkedin: LinkIcon(Linkedin),
    Twitter: LinkIcon(Twitter),
  },
  setup() {
    const emptyPorfolio: Portfolio = {
      name: '',
      overviewText: '',
      socials: {
        github: '',
        linkedin: '',
        twitter: '',
      },
      projects: [],
    };

    const portfolio = ref(emptyPorfolio);

    fetch('https://raw.githubusercontent.com/jsmith/portfolio-content/master/portfolio.json').then(async (res) => {
      const json = await res.json();
      const result = PortfolioType.decode(json);
      pipe(result, fold(
      (e) => {
        PathReporter.report(left(e)).forEach((error) => {
          // tslint:disable-next-line:no-console
          console.error(error);
        });
      },
      (value) => {
        portfolio.value = value;
      },
    ));
    });

    return {
      portfolio,
    };
  },
});
